module.exports = __webpack_public_path__ + "static/img/Dan-Houston.1648eb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dan-Houston.jpg
// module id = CvMZ
// module chunks = 0